import { Button } from 'antd';
import React from 'react';
import './index.scss';

interface PendingButtonProps {
  onClick?: () => void;
}

const PendingRequestConfirm: React.FC<PendingButtonProps> = ({
  onClick,
}) => {
  return (
    <Button className="pending-button" onClick={() => onClick?.()}>
      <span className="pending-button__icon">…</span>
    </Button>
  );
};

export default PendingRequestConfirm;
